import cx from "classnames";
import * as React from "react";

export interface QESRadioGroupProps {
  /**
   * A class for the div around all of the radio buttons
   */
  groupContainerClass?: string;
  /**
   * The label for the group as a whole
   * Does not cooperate with renderInline, unless you want the group label on the same line as the radios
   */
  groupLabel?: string;
  /**
   * ClassNames to add to the label
   */
  groupLabelClass?: string;
  /**
   * Whether a selection is required.
   */
  required?: boolean;
  /**
   * A simple flag that tells the group to render horizontally instead of vertically
   * Does not cooperate with groupLabel
   */
  renderInline?: boolean;
}

// /**
//  * This component renders a series of radio buttons, one for each provided label. They've been styled to match QES design guidelines.
//  */
export const QESRadioGroup: React.FC<React.PropsWithChildren<QESRadioGroupProps>> = (props: React.PropsWithChildren<QESRadioGroupProps>) => {
  return (
    <>
      <div
        className={cx({
          [props.groupContainerClass]: !!props.groupContainerClass,
          "qes-radio-group__container": true,
          "qes-radio-group__container--inline": props.renderInline,
        })}
      >
        {(props.groupLabel || props.required) && <p className={`qes-radio-group__group-label${props.groupLabelClass ? ` ${props.groupLabelClass}` : ""}`}>{props.groupLabel}{props.required && <span className="text-danger"> *</span>}</p>}
        {props.children}
      </div>
    </>
  );
};
